import React, { ReactElement } from 'react';

import TopMainLayout from '@/layouts/topMainNavigator';
import AlarmList from '@/containers/notification/AlarmList';

const Notification = () => {
    // 알람에 들어왔을 때 관련 푸시알람 없애기
    if (typeof window !== 'undefined' && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ channelURL: '' }));
    }

    return <AlarmList />;
};

Notification.getTopLayout = (page: ReactElement) => {
    return (
        <TopMainLayout title="알림" leftButton="back">
            {page}
        </TopMainLayout>
    );
};

export default Notification;
